import { Injectable } from '@angular/core';

@Injectable()
export class ItemsStateService {
    clonedItems: any[] = null;
    dynamicPageLayout: { [id: string]: any } = {};
    dynamicPageItems: { [id: string]: any } = {};

    constructor() { }
}